import type { FaireProductEntity } from "../../entity_types/product";

export const p_svajbjcywb: FaireProductEntity = {
  token: "p_svajbjcywb",
  type: "product",
  name: "Mug with Mushroom decal and brown glaze",
  brandToken: "b_qpb3ygknfs",
  brandName: "Divine Vessels Pottery",
  imageUrl:
    "https://cdn.faire.com/fastly/dd21ff252af977a388420f6da70c8cdf8178dbec43baf64ff42623896a68e1c3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2bfbdf4e76f3e9b1ac385fe5a5c07841c19988b0a8b9cd341b3bd4fa37c6743b.jpeg",
    "https://cdn.faire.com/fastly/2551ab84692b87dd337406df41702fdc3b07887eece55f6749893c8fb47188d3.jpeg",
    "https://cdn.faire.com/fastly/a1a02e947b81c29f85d3091e48e66686e05134daafe652dab3bc1ee0e0b8778b.jpeg",
    "https://cdn.faire.com/fastly/c9e973e915449edfbba6c9800fec7c0f6de684a33c0893b8fa057d0fdc17c10b.jpeg",
    "https://cdn.faire.com/fastly/dbf474513546c494903b21d8beb74709358af69ca27a7ba2263f55ebd79fb636.jpeg",
    "https://cdn.faire.com/fastly/fbf5b55dbf4cc3c16728bcd162228fbed06acd1c5bde8e2e26e9ab1a0bc51276.jpeg",
    "https://cdn.faire.com/fastly/8ab6459cd21d32496aaee317d78afdb1dc3a5cd4d72997b4bcbb092035cc3bee.png",
  ],
  priceDollars: 27.71,
  description:
    "Crafted from warm brown clay and finished with a rich dark brown glaze, this mushroom coffee mug combines artisanal quality with functional design. The detailed mushroom decal adds a natural, earthy aesthetic, making it a distinctive piece for your daily coffee ritual. Its sturdy construction ensures durability, while the comfortable handle provides ease of use. Ideal for those who appreciate handcrafted pottery with a touch of nature-inspired artistry.\n\n* Holds 12 oz. \n* Handmade in the USA\n* Woman owned business \n* Each piece is carefully handcrafted by the artist so there are slight variations from the                      item pictured. \n* This is stoneware pottery known for its rugged qualities\n* Dishwasher, microwave and oven safe. ",
  tags: [],
  msrpDollars: 52.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:31.667Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
